
/**
 * Speech Service for Sofia
 * Handles Text-to-Speech interactions for system announcements and strategy explanations.
 */

let synth: SpeechSynthesis | null = null;
if (typeof window !== 'undefined') {
    synth = window.speechSynthesis;
}

const getBestVoice = (): SpeechSynthesisVoice | null => {
    if (!synth) return null;
    const voices = synth.getVoices();
    // Prefer distinct, clear voices (Google, Daniel, Samantha)
    // Priority: Google Português do Brasil -> Luciana -> Felipe -> Default (pt-BR)
    return voices.find(v => v.name.includes('Google Português')) ||
        voices.find(v => v.name.includes('Luciana')) ||
        voices.find(v => v.lang === 'pt-BR') ||
        voices[0]; // Fallback
};

export const speak = (text: string, forceInterrupt: boolean = true) => {
    if (!synth) return;

    if (forceInterrupt) {
        synth.cancel();
    }

    const utterance = new SpeechSynthesisUtterance(text);
    const voice = getBestVoice();
    if (voice) utterance.voice = voice;

    utterance.volume = 1.0; // Max volume
    utterance.rate = 1.1;   // Slightly faster for dynamic feel
    utterance.pitch = 1.0;

    synth.speak(utterance);
};

export const cancelSpeech = () => {
    if (synth) synth.cancel();
};
